import { render, staticRenderFns } from "./ExchangeFailModal.vue?vue&type=template&id=58f70ff0&scoped=true"
import script from "./ExchangeFailModal.vue?vue&type=script&lang=js"
export * from "./ExchangeFailModal.vue?vue&type=script&lang=js"
import style0 from "./ExchangeFailModal.vue?vue&type=style&index=0&id=58f70ff0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f70ff0",
  null
  
)

export default component.exports